import { i18n, Locale, SUPPORTED_LOCALES } from '@/i18n.ts';
import { onMounted, watch } from 'vue';
import { LocalStorageService } from '@/modules/core/utils/local-storage-service.ts';
import { Settings } from 'luxon';
import { LocalStorageKey } from '@/modules/common/enums/local-storage-key.enum.ts';

export const useLocale = () => {
  function getValidLocale(locale: string | null): Locale | null {
    return SUPPORTED_LOCALES.find((supportedLocale) => supportedLocale === locale) || null;
  }

  function getPreferredLocale(): Locale | null {
    const languages = navigator.languages || [navigator.language];

    for (const language of languages) {
      const exactLocale = getValidLocale(language);

      if (exactLocale) {
        return exactLocale;
      }

      const code = language.split('-')[0];
      const locale = SUPPORTED_LOCALES.find((locale) => locale.startsWith(code));

      if (locale) {
        return locale;
      }
    }

    return null;
  }

  function getStoredLocale() {
    return getValidLocale(LocalStorageService.getString<Locale>(LocalStorageKey.Locale));
  }

  onMounted(() => (i18n.global.locale.value = getStoredLocale() || getPreferredLocale() || Locale.RuRU));

  watch(
    () => i18n.global.locale.value,
    (locale) => {
      Settings.defaultLocale = locale;
      document.documentElement.lang = locale;
      LocalStorageService.setString(LocalStorageKey.Locale, locale);
    },
  );
};
